$('.content-slider').each(function() {
    var slider = $(this),
        productsPer = slider.data('products-per'); // Get products per slider

    // Initialize the slider with dynamic productsPer value
    slider.slick({
        dots: true,
        arrows: true,
        infinite: true,
        focusOnSelect: true,
        speed: 300,
        slidesToShow: productsPer,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: productsPer } },
            { breakpoint: 767, settings: { slidesToShow: 2.5, infinite: false } },
            { breakpoint: 480, settings: { slidesToShow: 1.5, infinite: false } }
        ]
    }).on('init reInit afterChange', function(event, slick, currentSlide) {
        // Ensure we start at 1, not 0
        currentSlide = currentSlide === undefined ? 0 : currentSlide;
        var current = currentSlide + 1; // 1-based index
        var total = slick.slideCount;

        // Update current and total slide counters
        slider.closest('.one-whole').find('.current-slide').text(current);
        slider.closest('.one-whole').find('.total-slides').text(total);

        // Handle next/prev arrow visibility and disable states
        var $nextArrow = slider.closest('.one-whole').find('.slick-next');
        var $prevArrow = slider.closest('.one-whole').find('.slick-prev');
        $nextArrow.toggleClass('slick-disabled', current === total).attr('disabled', current === total);
        $prevArrow.toggleClass('slick-disabled', current === 1).attr('disabled', current === 1);
    });

    // Manually trigger 'init' to set initial values for current/total slides if necessary
    slider.slick('slickGoTo', 0);
});
